export default function RollDiceRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px !important;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                `}
            </style>

            <div class="modal fade show" id="rulesPopup" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static" style={{ display: "block" }}>
                <div class="modal-dialog" role="document">
                    <div class="modal-content" style={{ backgroundColor: "#3C444B", color: "#AAAFB5", borderRadius: "6px" }}>
                        <div class="modal-header" style={{ borderBottom: "0px", padding: "5px", background: "#e0e0e0" }}>
                            <div class="modal-title" id="exampleModalLabel" style={{ fontSize: "20px", color: "rgba(0,0,0,.87)", margin: "5px 0px 0px 10px" }}><b>Roll Dice Rules</b></div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" style={{ color: "white", margin: "-0.5rem -0.7rem -1rem auto" }} onClick={onClose}>
                                <span aria-hidden="true" style={{ color: "#000", opacity: "0.8" }}>×</span>
                            </button>
                        </div>
                        <div class="modal-body" style={{ marginTop: "0px", background: "#fff" }}>
                            <div style={{ background: "#fff", padding: "10px", borderRadius: "10px" }}>
                                <div class="row">
                                    <div class="col-lg-12" style={{ color: "rgba(0,0,0,.87)" }}>
                                        <p>It opens all day. 15 seconds to show the lottery result.</p>
                                        <p>If you spend 100 to trade, after deducting 2 service fee, your contract amount is 98:</p>

                                        <div class="row">
                                            <div class="col-6">
                                                <h5>UNDER</h5>
                                                <ul>
                                                    <li>3 : 15.30</li>
                                                    <li>4 : 8.15</li>
                                                    <li>5 : 4.25</li>
                                                    <li>6 : 3.10</li>
                                                    <li>7 : 2.3</li>
                                                    <li>8 : 1.50</li>
                                                    <li>9 : 1.30</li>
                                                    <li>10 : 1.15</li>
                                                    <li>11 : 1.05</li>
                                                </ul>
                                            </div>
                                            <div class="col-6">
                                                <h5>OVER</h5>
                                                <ul>
                                                    <li>3 : 1.05</li>
                                                    <li>4 : 1.15</li>
                                                    <li>5 : 1.30</li>
                                                    <li>6 : 1.50</li>
                                                    <li>7 : 2.30</li>
                                                    <li>8 : 3.10</li>
                                                    <li>9 : 4.25</li>
                                                    <li>10 : 8.15</li>
                                                    <li>11 : 15.30</li>
                                                </ul>
                                            </div>
                                        </div>


                                        <p style={{ marginTop: "15px", marginBottom: "5px" }}>If you JOIN UNDER (10) and the result shows 6, you will get (98*1.15) 112.7</p>
                                        <p style={{ marginTop: "5px" }}>Only Two Bet Allowed in One Round.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}